import manager from '../manager';
import $ from 'jquery'
import Modal from '@/v-ui/Modal';
import translate from '@/utils/translate';
import http from '@/utils/http'
import { SLD } from '@/utils/INTERFACE'
import { getSite } from '@/utils/site';
import { getPlatform } from '@/utils/page'

async function subscript(email) {
    await http.jsonp.get(`${SLD().rest}/act/subscribe`, {
        email,
        site: getSite()
    })
}

manager.add('activitySubscript', {
    created() {
        var { platform } = getPlatform()
        $(this.dom).on("click", () => {
            let modal
            if (platform == 'pc') {
                modal = new Modal(`
                    <p style="font-size: 16px;color: #565656;font-weight:bold">${translate('Please enter the email address you use to receive activity subscription')}:</p>
                    <div class="input-box" style="height:44px;background: #EFEFEF;margin-top:22px;position: relative;">
                        <input style="height: 100%;background: none;border: none;padding-left:20px;padding-right:150px;box-sizing: border-box;font-size: 16px;font-weight: bold;width: 100%;" />
                        <div class="status-success" style="display:none;line-height: 42px;padding: 0 10px;position:absolute;right:0;top:0;">
                            <img src="//img13.360buyimg.com/uba/jfs/t16621/219/1049409712/2664/4d7cadc0/5ab8acc4N8d6f0b83.png" style="width: 18px;height: 18px;vertical-align: middle;" />
                            <span style="vertical-align: middle;font-size: 12px;color:#66b659">${translate('Submitted successfully')}</span>
                        </div>
                        <div class="status-error" style="display:none;line-height: 42px;padding: 0 10px;position:absolute;right:0;top:0;">
                            <img src="//img10.360buyimg.com/uba/jfs/t18691/77/1037601014/2078/c8d24cfb/5ab8b0dcN0f6af9af.png" style="width: 18px;height: 18px;vertical-align: middle;" />
                            <span style="vertical-align: middle;font-size: 12px;color:#f19951"></span>
                        </div>
                    </div>
                    <div class="button-group" style="text-align:center">
                        <button class="close flat">${translate('Cancel')}</button>
                        <button class="confirm" style="background: #565656;border-color:#565656;">${translate('Submit')}</button>
                    </div>
                    `, {
                        style: "width:420px;text-align:left"
                    })
            }else{
                modal = new Modal(`
                    <p style="font-size: 16px;color: #565656;font-weight:bold">${translate('Please enter the email address you use to receive activity subscription')}:</p>
                    <div class="input-box" style="height:44px;background: #EFEFEF;margin-top:22px;position: relative;">
                        <input style="height: 100%;background: none;border: none;padding-left:20px;padding-right:20px;box-sizing: border-box;font-size: 16px;font-weight: bold;width: 100%;" />
                    </div>
                    <div class="status-box" style="line-height: 32px;height:32px;">
                        <div class="status-success" style="display:none;padding: 0 10px;">
                            <img src="//img13.360buyimg.com/uba/jfs/t16621/219/1049409712/2664/4d7cadc0/5ab8acc4N8d6f0b83.png" style="width: 18px;height: 18px;vertical-align: middle;" />
                            <span style="vertical-align: middle;font-size: 12px;color:#66b659">${translate('Submitted successfully')}</span>
                        </div>
                        <div class="status-error" style="display:none;padding: 0 10px;">
                            <img src="//img10.360buyimg.com/uba/jfs/t18691/77/1037601014/2078/c8d24cfb/5ab8b0dcN0f6af9af.png" style="width: 18px;height: 18px;vertical-align: middle;" />
                            <span style="vertical-align: middle;font-size: 12px;color:#f19951"></span>
                        </div>
                    </div>
                    <div class="button-group" style="text-align:center;margin-top:0;">
                        <button class="close flat">${translate('Cancel')}</button>
                        <button class="confirm" style="background: #565656;border-color:#565656;">${translate('Submit')}</button>
                    </div>
                    `, {
                        style: "width:80vw;text-align:left",
                        noClose:true
                    })
            }

            let box = modal.content
            let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            box.find(".confirm").on("click", async () => {
                let email = box.find("input").val()
                if (!reg.test(email)) {
                    box.find(".status-success").hide()
                    box.find(".status-error span").text(translate("Incorrect format"))
                    box.find(".status-error").fadeIn()
                    return
                }
                box.find(".status-error").hide()
                try {
                    await subscript(email)
                } catch (err) {
                    box.find(".status-success").hide()
                    box.find(".status-error span").text(err.message)
                    box.find(".status-error").fadeIn()
                    return
                }
                box.find(".status-success").fadeIn()
                setTimeout(() => modal.hide(), 1000)
            })
            modal.show()

        })
    }
})
